import React, { useState, useEffect  } from "react";
import { Redirect } from "react-router-dom";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import  getExperimentExcel  from '../components/getExperimentExcel'
import GPAP_Button from "../../../../gpap-lib/Button_Collection";
import TsvUploader from "../../components/TsvUploader";
import auth from '../../../service/Auth'
import AuthErrorDialog from "../components/AuthError";


const ExperimentTemplateSubmission =(props)=>{

    const [data, setData] = useState([]);
    const [back, setBack] = useState(false);
    const [next, setNext] = useState(false);
    const [authError, setAuthError] = useState("");

    useEffect(() => {   
        if (auth.tokenExpired()){  
            setAuthError("Logging session timeout. Please log again");
        }
    });

    const getTemplate = (event) => {
        getExperimentExcel();
    }

    const uploadTsv = (data) => { 
        setData(data);
        setNext(true);
    }
    const goBack = (event) => { setBack(true); } 
    const goNext = (event) => { setNext(true); }

    /* OpenID session token error*/
    if (authError !== "" ) {
        return (
            <AuthErrorDialog errors={authError} open={true}/>
        );
    }

    /*Go to experiment submission choices*/
    if (back) {
        return  <Redirect to={{pathname:'/experimentsubmissionchoices', owner:props.location.owner}}/>;
    }

    /*Go to Files Submission*/
    if (next) {
        return  <Redirect to={{pathname:'/submitexperiments', owner:props.location.owner, data:data}}/>;
    }

    return (
        <div className={"mainContent"}>
            <Typography variant={"h5"} align={"center"}> Submit Experiments </Typography>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
            >
                <Card sx={{ m:2, minWidth: 275 }}>
                    <CardContent>
                        {/* Fill in our template*/}
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            sx={{ m: 2 }}
                        >
                            <Typography variant="h5" component="div" align={"center"}>
                                Fill in our template
                            </Typography>
                            <GPAP_Button onClick={getTemplate}> 
                                <i className="fa fa-download" aria-hidden="true"/> 
                                Download template
                            </GPAP_Button>
                        </Grid>
                        {/* Upload File*/}
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            sx={{ m: 2 }}
                        >
                            <Typography variant="h5" component="div" align={"center"}>
                                Do you have already filled in the template?
                            </Typography>
                            
                            <TsvUploader uploadTsv={uploadTsv}/>
                        </Grid>
                    </CardContent>
                    <CardActions>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <GPAP_Button onClick={goBack}> 
                                <i class="fa fa-arrow-circle-left" aria-hidden="true"></i> 
                                BACK 
                            </GPAP_Button>
                            <GPAP_Button onClick={goNext}> NEXT 
                                <i class="fa fa-arrow-circle-right" aria-hidden="true"></i> 
                            </GPAP_Button>
                        </Grid>
                    </CardActions>
                </Card>
            </Grid>
        </div>
    );

}

export default ExperimentTemplateSubmission;
